import React, { useEffect } from "react";
import { logoutUser } from "store/actions";

//redux
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUser(navigate as any));
  }, [dispatch, navigate]);

  return <></>;
};

export default Logout;